import "./forgotPassword.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "../../helpers/alert";
import { FormattedMessage, useIntl } from "react-intl";
import { forgotPassword } from "../../redux/apiCalls/forgot_passCall/forgot_passCall";
import { logoutForgotPass } from "../../redux/reducers/forgotPass/forgot_passRedux";
import ExpiredIllustration from "../../assets/Time_management-rafiki.svg";

const ForgotPassword = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { isFetching, error, currentData, errorMessage, errorStatus } = useSelector(
    (state) => state.forgotPassword
  );

  const [email, setEmail] = useState("");
  const [showRateLimit, setShowRateLimit] = useState(false);

  const handleSendResetEmail = async (e) => {
    e.preventDefault();
    if (!email || isFetching) return;
    await forgotPassword(dispatch, email); 
  };


  useEffect(() => {
    if (!isFetching && currentData) {
      Toast.fire({
        icon: "success",
        title:
          currentData?.message ||
          intl.formatMessage({
            id: "Password.ResetEmailSent",
            defaultMessage: "Enviamos un enlace si el correo existe.",
          }),
      });
      setEmail("");
      dispatch(logoutForgotPass());
    }
  }, [isFetching, currentData, intl, dispatch]);


  useEffect(() => {
    if (!isFetching && error) {
      if (errorStatus === 429) { setShowRateLimit(true); return; }

      Toast.fire({
        icon: "error",
        title:
          errorMessage ||
          intl.formatMessage({
            id: "RequestFailed",
            defaultMessage: "La solicitud falló. Intente nuevamente.",
          }),
      });

      dispatch(logoutForgotPass());
    }
  }, [isFetching, error, errorMessage, intl, dispatch]);

  const closeRateLimitModal = () => {
    setShowRateLimit(false);
    dispatch(logoutForgotPass());
  };


  if (showRateLimit) {
    return (
      <div
        className="modal d-block"
        tabIndex="-1"
        aria-labelledby="rateLimitTitle"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="rateLimitTitle">
                <FormattedMessage
                  id="Password.RateLimitTitle"
                  defaultMessage="Has alcanzado el límite diario"
                />
              </h1>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeRateLimitModal}
              />
            </div>
            <div className="modal-body modal-pass" style={{ textAlign: "center" }}>
              <img
                src={ExpiredIllustration}
                alt={intl.formatMessage({
                  id: "Password.RateLimitImageAlt",
                  defaultMessage: "Límite diario alcanzado",
                })}
                style={{ maxWidth: "100%", height: "auto", marginBottom: 16 }}
              />
              <p style={{ margin: 0 }}>
                <small>
                  <FormattedMessage
                    id="Password.RateLimitMessage"
                    defaultMessage="Espere un día para volver a restablecer la contraseña."
                  />
                </small>
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-closeModal"
                onClick={closeRateLimitModal}
              >
                <FormattedMessage
                  id="ProfileInformation.Close"
                  defaultMessage="Cerrar"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-page container-login container-fluid">
      <form className="formLogin" onSubmit={handleSendResetEmail}>
        <h1>
          <FormattedMessage
            id="ForgotPassword.Title"
            defaultMessage="Restablecer su contraseña"
          />
        </h1>

        <input
          className="input-form"
          type="email"
          name="email"
          placeholder={intl.formatMessage({
            id: "Email",
            defaultMessage: "Email",
          })}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />

        <button className="btnLogin" type="submit" disabled={isFetching}>
          {isFetching
            ? intl.formatMessage({ id: "Sending", defaultMessage: "Enviando..." })
            : intl.formatMessage({
                id: "SendResetLink",
                defaultMessage: "Enviar enlace de restablecimiento",
              })}
        </button>

        <p className="hint">
          <small>
            <FormattedMessage
              id="ForgotPassword.Hint"
              defaultMessage="Si el correo electrónico existe, enviaremos un enlace para restablecerlo."
            />
          </small>
        </p>
      </form>
    </div>
  );
};

export default ForgotPassword;
